// extracted by mini-css-extract-plugin
export default {"container":"ellipsis-table-cell_container__e9+UG"};